module.exports = __webpack_public_path__ + "_assets/img/store.1f80355e.svg";